export const metaTitle = (newTitle: string) => (document.title = newTitle);
